import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Vuelidate from 'vuelidate';
import VCalendar from 'v-calendar';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import Multiselect from 'vue-multiselect';
import VueGtag from 'vue-gtag';

library.add(fas);

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(VCalendar);
Vue.component('multiselect', Multiselect);

Vue.use(
    VueGtag,
    {
        config: { id: process.env.VUE_APP_GTAG_ID },
    },
    router,
);

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
